import { FC } from 'react';
import AddProductProvider from '../memory/memr';
import InitMiddlewareAddUser from '../middlewares/InitMiddleware';

const AddUserInstance: FC<{}> = () => {
  return (
    <AddProductProvider>
      <InitMiddlewareAddUser />
    </AddProductProvider>
  );
};

export default AddUserInstance;
